export const ACT_GET_ACTS = 'ACT_GET_ACTS';
export const SET_ACT_CHECKLIST_INTERIOR_ACCESSORIES = 'SET_ACT_CHECKLIST_INTERIOR_ACCESSORIES';
export const SET_ACT_CHECKLIST_EXTERIOR_ACCESSORIES = 'SET_ACT_CHECKLIST_EXTERIOR_ACCESSORIES';
export const SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM = 'SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM';
export const DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM =
  'DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM';
export const EDIT_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM = 'EDIT_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM';
export const SET_ACT_PROPERTY = 'SET_ACT_PROPERTY';
export const ACT_GET_ACT = 'ACT_GET_ACT';
export const UI_UPDATE_FROM_PARTNER = 'UI_UPDATE_FROM_PARTNER';
export const ACT_ERROR = 'ACT_ERROR';
export const ACT_CMS = 'ACT_CMS';
export const ACT_SAVE_DATA = 'ACT_SAVE_DATA';
export const ACT_SAVE_DATA_TRANSFER = 'ACT_SAVE_DATA_TRANSFER';
export const END_SIGN = 'END_SIGN';
export const CANCEL_ACT = 'CANCEL_ACT';
export const CANCEL_ACT_TRANSFER = 'CANCEL_ACT_TRANSFER';
export const VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT';
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const REMOVE_IDENTITY = 'REMOVE_IDENTITY';
export const SET_ACT_CHECKLIST_INTERIOR_BREAKS_ITEM = 'SET_ACT_CHECKLIST_INTERIOR_BREAKS_ITEM';
export const RESET_CHECK_TRANSFER_FILTERS = 'RESET_CHECK_TRANSFER_FILTERS';
export const ACT_GET_TRANSFER_ACTS = 'ACT_GET_TRANSFER_ACTS';
export const ACT_GET_TRANSFER_ACT = 'ACT_GET_TRANSFER_ACT';
export const ACT_RESET_DATA_TO_SEND = 'ACT_RESET_DATA_TO_SEND';
export const ACT_RESET_TIRES = 'ACT_RESET_TIRES';
export const GET_DISCREPANCIES_FLEX_CHECK = 'GET_DISCREPANCIES_FLEX_CHECK';
export const GET_REQUIRED_DOCUMENTATION = 'GET_REQUIRED_DOCUMENTATION';
